'use strict';

class CitiesController {
  /* @ngInject */
  constructor(CitiesService, $scope, $q) {
    Object.assign(this, {
      CitiesService,
      $scope,
      $q
    });

    this.query = {
      include: ['province'],
      where: {},
      limit: 10,
      page: 1,
      order: 'name ASC'
    };

    this.getCities();

    this.onPagination = () => {
      this.getCities();
    };
  }

  getCities() {
    let qOpts = JSON.parse(JSON.stringify(this.query));
    if (this.whereName) {
      qOpts.where.name = {
        ilike: `%${this.whereName}%`
      };
    }

    let queryReady = this.CitiesService.getModels(qOpts).then(cities => {
      this.cities = cities;
    });
    let countReady = this.CitiesService.getCount(qOpts).then(result => {
      this.citiesCount = result.count;
    });
    this.promise = this.$q.all([queryReady, countReady]);
    return this.promise;
  }
}

export default CitiesController;
